function GetHelp(x) {

    $('.help_div').hide();
    $('.help_' + x).show();
    $('.help_' + x).children("div.subhelp:first").show();

}
 
$(document).ready(function () {

    $('.help_Uyelik, .help_Uyelik .subhelp:first').show();
    $('#helpMenu ul li:first a').addClass("secili");


    $('#helpMenu ul li a').on('click', function (e, index) {

        $('#helpMenu ul li a').removeClass('secili');
        $(this).addClass('secili');
        GetHelp($(this).attr('href').replace(/#/ig, ""));
    });

    $('.subhelptitle').on('click', function (e, index) { 


        var c = $(this).attr('id').replace(/title/, "");
        $('.subhelp:visible').slideUp('fast');
        $('.' + c).slideDown('fast');

    });

    $("#HelpNavs div ul").first().show();
    $("#HelpContents ul li").hide();
    $("#HelpContents div").eq($("#HelpNavs div .HelpNavTitles").first().parent().index()).find("ul li:first").show();

    $('#HelpNavs li').click(function () {

        $("#HelpContents ul li").hide();

        $("#HelpContents div").eq($(this).closest("div").index()).find("ul li").eq($(this).index()).show();

    });

    $('#HelpNavs > div').click(function () {


        $("#HelpNavs div > ul").hide();
        $(this).find("ul").show("normal");


    });

    $('.HelpNavTitles').click(function () {

        $("#HelpContents ul li").hide();
        $("#HelpContents div").eq($(this).parent().index()).find("ul li:first").show();

    });

});

